import styled from '@emotion/styled';

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.lightGrey};
`;
